// 通用配置
export * from './interface/config';
export { default as Layer, LayerConfig } from './base/layer';
export { default as ViewLayer, ViewConfig } from './base/view-layer';
export { default as Base, PlotConfig } from './base/plot';

// 图形
export * from './plots/index';

// MINI 图形
export { TinyLayerConfig } from './sparkline/tiny-layer';
export { default as Progress, ProgressConfig } from './sparkline/progress';
export { default as RingProgress, RingProgressConfig } from './sparkline/ring-progress';
export { default as TinyColumn, TinyColumnConfig } from './sparkline/tiny-column';
export { default as TinyArea, TinyAreaConfig } from './sparkline/tiny-area';
export { default as TinyLine, TinyLineConfig } from './sparkline/tiny-line';

// 混合图形
export { default as OverlappedComboPlot, OverlappedComboPlotConfig } from './combo-plots/overlapped';

// 主题
export { registerTheme, registerGlobalTheme } from './theme';
export { registerResponsiveConstraint, IConstraint } from './util/responsive/constraints';
export { registerResponsiveRule } from './util/responsive/rules';
export { registerResponsiveTheme, getResponsiveTheme } from './util/responsive/theme';

export { default as StateManager } from './util/state-manager';
